<div class="documents-dialog" *ngIf="active">
  <div class="documents-dialog__content">
    <button class="documents-dialog__content__close" (click)="closeDialog()">
      <span class="material-icons">close</span>Close
    </button>
    <h2>Confirm SMS Opt-In</h2>
    <ng-container>
      <div class="">
        <div class="mb-10">
          <div
            *ngIf="user.phone && user.phone2; else singlePhoneSelection"
            [formGroup]="phoneFormGroup"
          >
            <p>
              You’re about to opt in for SMS notifications. Please choose the
              phone number you’d like to use:
            </p>
            <div>
              <label>
                <input
                  type="radio"
                  formControlName="selectedPhone"
                  [value]="user.phone"
                  style="width: auto"
                />
                Primary Phone Number:
                <span style="font-weight: bold">{{ user.phone }}</span>
              </label>
            </div>
            <div>
              <label>
                <input
                  type="radio"
                  formControlName="selectedPhone"
                  [value]="user.phone2"
                  style="width: auto"
                />
                Secondary Phone Number:
                <span style="font-weight: bold">{{ user.phone2 }}</span>
              </label>
            </div>
          </div>
          <ng-template #singlePhoneSelection>
            <p>
              You're about to opt in to receive SMS notifications using the
              phone number you provided:
              <b>{{ user.phone ? user.phone : user.phone2 }}.</b>
            </p>
            <p>Do you want to proceed?</p>
          </ng-template>
        </div>
        <br />
        <div class="container mt-30">
          <div class="column column-left">
            <div class="documents-dialog__content__footer__service-type">
              <a
                href="https://cretelligent.com/website-terms-of-use/"
                target="_blank"
                rel="noopener noreferrer"
                >Terms & Conditions</a
              >
              <a
                href="https://cretelligent.com/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
                style="margin-left: 22px"
                >Privacy Policy</a
              >
            </div>
          </div>
          <div class="right-columns panelfields">
            <div class="column">
              <button type="submit" class="btn btn-primary" (click)="submit()" [disabled]="isSubmitting">
                Opt-In
              </button>
            </div>
            <div class="column">
              <button
                type="submit"
                class="btn btn-default"
                (click)="closeDialog()"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="documents-dialog__background" (click)="closeDialog()"></div>
</div>
